module.exports = "/images/volcano@3x.png?32f0c084308e2053352662206dbd1be8";